import { render, staticRenderFns } from "./AnnouncementBox.vue?vue&type=template&id=29356942"
import script from "./AnnouncementBox.vue?vue&type=script&lang=js"
export * from "./AnnouncementBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports